import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormikContext, FieldArray } from "formik";
import SectionHeading from "../common/SectionHeading";
import DynamicFieldGroup from "../common/DynamicFieldGroup";
import RowGroup from "../common/RowGroup";
import CloseIcon from "@mui/icons-material/Close";

const MonthlyExpences = ({ formField }) => {
  const { flatType, flatAmount, carEmi, bikeEmi, schoolFees } = formField;

  const { values, setFieldValue, errors, touched } = useFormikContext();
  //  console.log("form field values monthly exp", values);
  const isSmallDevice = useMediaQuery("(max-width:600px)");

  return (
    <Box sx={{ p: isSmallDevice ? 0.5 : 1, maxWidth: 1000, mx: "auto" }}>
      <Paper
        elevation={3}
        sx={{
          p: isSmallDevice ? 2 : 3,
          position: "relative",
          border: "1px solid #e0e0e0",
          borderRadius: 3,
        }}
      >
        {/* <SectionHeading title="Monthly Expenses" number={3} /> */}

        {/* Flat Section */}
        <div className="mb-3">
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            1. Flat Expenses:
          </Typography>

          <DynamicFieldGroup
            showDropdown={true}
            dropdownOptions={[
              { value: "EMI", label: "EMI" },
              { value: "Rent", label: "Rent" },
            ]}
            dropdownValue={values.monthlyExpenses?.flatType || ""}
            onDropdownChange={(e) =>
              setFieldValue("monthlyExpenses.flatType", e.target.value)
            }
            dropdownLabel="Select Type"
            showSlider={values.monthlyExpenses?.flatType ? true : false}
            sliderValue={values.monthlyExpenses?.flatAmount || 0}
            onSliderChange={(e, newValue) => {
              setFieldValue("monthlyExpenses.flatAmount", newValue);
            }}
            sliderMin={0}
            sliderMax={1000000}
            sliderStep={1000}
            showInputField={values.monthlyExpenses?.flatType ? true : false}
            inputValue={values.monthlyExpenses?.flatAmount || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("monthlyExpenses.flatAmount", newValue);
            }}
            inputLabel="Amount ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
          {touched.monthlyExpenses?.flatType &&
            errors.monthlyExpenses?.flatType && (
              <div className="text-danger mt-1">
                {errors.monthlyExpenses.flatType}
              </div>
            )}
        </div>

        {/* Car EMI Section */}
        <div className="mb-3">
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            2. Car EMI Expenses:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.monthlyExpenses?.carEmi || 0}
            onSliderChange={(e, newValue) => {
              setFieldValue("monthlyExpenses.carEmi", newValue);
            }}
            sliderMin={0}
            sliderMax={1000000}
            sliderStep={1000}
            showInputField={true}
            inputValue={values.monthlyExpenses?.carEmi || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("monthlyExpenses.carEmi", newValue);
            }}
            inputLabel="Amount ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </div>

        {/* Bike EMI Section */}
        <div className="mb-3">
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            3. Bike EMI Expenses:
          </Typography>
          <DynamicFieldGroup
            showSlider={true}
            sliderValue={values.monthlyExpenses?.bikeEmi || 0}
            onSliderChange={(e, newValue) => {
              setFieldValue("monthlyExpenses.bikeEmi", newValue);
            }}
            sliderMin={0}
            sliderMax={1000000}
            sliderStep={1000}
            showInputField={true}
            inputValue={values.monthlyExpenses?.bikeEmi || ""}
            onInputChange={(e) => {
              const newValue = Number(e.target.value) || 0;
              setFieldValue("monthlyExpenses.bikeEmi", newValue);
            }}
            inputLabel="Amount ₹"
            inputType="number"
            sx={{
              width: isSmallDevice ? "100%" : "100%",
              border: isSmallDevice ? "1px solid #e0e0e0" : "none",
              p: isSmallDevice ? 2 : 0,
              borderRadius: 1,
            }}
          />
        </div>

        {/* School Fees Section */}
        <FieldArray name="monthlyExpenses.schoolFees">
          {({ push, remove }) => (
            <div className="row mb-3">
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                }}
              >
                4. Approx Monthly School Fees:
              </Typography>

              {values.monthlyExpenses?.schoolFees?.map((fee, index) => (
                <Box
                  key={index}
                  sx={{
                    mb: 3,
                    position: "relative",
                    p: { xs: 2, sm: 0 },
                    // mx: isSmallDevice ? -1 : 2,
                    borderRadius: 1,
                    border: "1px solid #e0e0e0",
                    // boxShadow: { xs: 2, sm: 0 },
                    // border: { xs: "1px solid #e0e0e0", sm: "none" },
                    backgroundColor: { xs: "#fff", sm: "transparent" },
                  }}
                >
                  {isSmallDevice &&
                    values.monthlyExpenses.schoolFees.length > 1 && (
                      <IconButton
                        size="small"
                        aria-label={`remove rental ${index}`}
                        onClick={() => remove(index)}
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          backgroundColor: "rgba(0,0,0,0.04)",
                          zIndex: 5,
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                  <DynamicFieldGroup
                    title={`Child ${fee.child} School Fee`}
                    showSlider={true}
                    sliderValue={
                      values.monthlyExpenses.schoolFees[index].amount || 0
                    }
                    onSliderChange={(e, newValue) => {
                      setFieldValue(
                        `monthlyExpenses.schoolFees[${index}].amount`,
                        newValue,
                      );
                    }}
                    sliderMin={0}
                    sliderMax={1000000}
                    sliderStep={1000}
                    showInputField={true}
                    inputValue={
                      values.monthlyExpenses.schoolFees[index].amount || ""
                    }
                    onInputChange={(e) => {
                      const newValue = Number(e.target.value) || 0;
                      setFieldValue(
                        `monthlyExpenses.schoolFees[${index}].amount`,
                        newValue,
                      );
                    }}
                    inputLabel="Fees ₹"
                    showRemoveButton={
                      !isSmallDevice &&
                      values.monthlyExpenses.schoolFees.length > 1
                    }
                    onRemove={() => remove(index)}
                  />
                </Box>
              ))}

              {/* Add Child Button */}
              <div className="d-flex justify-content-end mt-1">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => {
                    const nextChild =
                      (values.monthlyExpenses?.schoolFees?.length || 0) + 1;
                    push({ child: nextChild, amount: 0 });
                  }}
                >
                  + Add Child Details
                </button>
              </div>
            </div>
          )}
        </FieldArray>
      </Paper>
    </Box>
  );
};

export default MonthlyExpences;
